import * as colors from 'color-name';

export class GeneratorUtil {
    private static readonly symbolUpperCases: string[] = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'K', 'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
    private static readonly symbolLowerCases: string[] = [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'k', 'm', 'n', 'p', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
    ];

    public static code(size: number): string {
        if (size === null || size === undefined) {
            size = 6;
        }

        let code: string = '';
        while (code.length < size) {
            code += GeneratorUtil.symbolUpperCases[GeneratorUtil.int(0, GeneratorUtil.symbolUpperCases.length - 1)];
        }

        return code;
    }

    public static color(alpha: number = 1): string {
        const alphaHex: string = GeneratorUtil.rgbToHex(Math.round(255 * alpha));
        const defaultColor: string = '#000000' + alphaHex;
        const colorList: number[][] = Object.values(colors);
        if (colorList.length === 0) {
            return defaultColor;
        }
        const rgb: number[] = colorList[GeneratorUtil.int(0, colorList.length - 1)];
        if (rgb.length !== 3) {
            return defaultColor;
        }

        return '#' +  GeneratorUtil.rgbToHex(rgb[0]) + GeneratorUtil.rgbToHex(rgb[1]) + GeneratorUtil.rgbToHex(rgb[2]) + alphaHex;
    }

    private static rgbToHex(rgb: number): string {
        const hex: string = rgb.toString(16);
        if (hex.length === 1) {
            return '0' + hex;
        }

        return hex;
    }

    public static int(min: number, max: number): number {
        if (min === null || min === undefined) {
            min = 0;
        }
        if (max === null || max === undefined) {
            max = Number.POSITIVE_INFINITY;
        }

        min = Math.ceil(min);
        max = Math.floor(max);

        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public static password(size: number): string {
        if (size === null || size === undefined) {
            size = 8;
        }

        let code: string = '';
        while (code.length < size) {
            switch (GeneratorUtil.int(1, 3)) {
                case 1:
                    code += GeneratorUtil.symbolUpperCases[GeneratorUtil.int(0, GeneratorUtil.symbolUpperCases.length - 1)];
                    break;
                case 2:
                    code += GeneratorUtil.symbolLowerCases[GeneratorUtil.int(0, GeneratorUtil.symbolLowerCases.length - 1)];
                    break;
                default:
                    code += String(GeneratorUtil.int(0, 9));
            }
        }

        return code;
    }
}
